import { CustomerSessionPartner } from '@sales-domain/product-config';

type CallTypes = {
  [key in CustomerSessionPartner]?: {
    name: string;
    value: string;
  }[];
};

export const callTypes: CallTypes = {
  [CustomerSessionPartner.Mcafee]: [
    {
      name: 'McAfee Assist +',
      value: 'Assist',
    },
    {
      name: 'McAfee Tech Support',
      value: 'Tech Support',
    },
    {
      name: 'Ghost Call',
      value: 'Ghost',
    },
    {
      name: 'Transfer',
      value: 'Transfer',
    },
    {
      name: 'Other',
      value: 'Other',
    },
  ],
  [CustomerSessionPartner.Optimum]: [
    {
      name: 'Fiber as the Fix',
      value: 'Fiber as the Fix',
    },
    {
      name: 'Other',
      value: 'Other',
    },
  ],
};
